<app-base-modal [disableClose]="true" [title]="currentLabels.title | translate" bodyClass="none">
    <app-circle-warn header></app-circle-warn>
    <app-plain-text-content content [text]="currentLabels.text | translate: { seconds: seconds }"></app-plain-text-content>
    <app-action-confirm actions
        type="done"
        [doneBtnTitle]="currentLabels.confirmButtonTitle"
        class="inactive-modal"
        (doneClick)="action()">
    </app-action-confirm>
</app-base-modal>
